/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react'
import { ToastContainer } from 'react-toastify'
import moment from 'moment/moment'
import Spinner from '../../Components/spinner/spinner'
import Paginations from '../../Components/Pagination/pagination'
import Offer from '../../Assets/images/offers.jpg';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import NoRecord from '../../Components/noRecord';
import AddOffer from './addOffer'
import EditOffer from './editOffer'
import UseOffer from './Hooks/useOffer'
import UseImage from '../../Hooks/useImage'
import { intialRole } from '../../Utils/Utils'
import { Modal } from 'react-bootstrap'
import { Button } from '@mui/material'


const OfferList = () => {
  const {
    valuetext,
    handleChange,
    offerList,
    offerView,
    servicesList,
    offerDelete,
    setImageData,
    setInActive,
    setOfferId,
    setShow,
    setShowOffer,
    setFilter,
    setPage,
    navigate,
    setMale,
    setFemale,
    setOther,
    setShowDelete,
    setRewardOffer,
    setZeroOffer,
    SetSendPromotionMsg,
    getClientList,
    handleSubmit,
    handleToggle,
    clear,
    handleSelectAll,
    buyPlanNavigate,
    getAvailableCreditLimit,
    navigatePromotionalMessage,
    handleSearch,
    setGender,
    handleGenderChange,
    isAllSelected,
    selectedClients,
    sendPromotionMsg,
    showDelete,
    rewardOffer,
    zeroOffer,
    createOffer,
    editOffer,
    value,
    imageData,
    serviceList,
    inActive,
    offerListData,
    selectedService,
    show,
    showOffer,
    spinner,
    filter,
    count,
    page,
    PER_PAGE,
    male,
    female,
    other,
    date,
    imgFolder,
    offerId,
    fileInputRef,
    clientList,
    userInfo,
    creditLimitModalMsg,
    creditLimit,
    query,
    gender,
  } = UseOffer()
  const { imageDeleteUpload, imageDelete, uploadImage } = UseImage()
  const Edit_Permission = intialRole({ permission: "offers", userData: userInfo, section: 'edit' })
  const Delete_Permission = intialRole({ permission: "offers", userData: userInfo, section: 'delete' })
  const Create_Permission = intialRole({ permission: "offers", userData: userInfo, section: 'create' })
  const View_Permission = intialRole({ permission: "offers", userData: userInfo, section: 'view' })

  const handleClick = (item, type) => {
    if (Edit_Permission) {
      offerView(item._id, type);
      setRewardOffer(item.offerType === 'REWARDS');
    }
  };


  return (
    <>
      <ToastContainer />
      <section className="position-relative">
        <div className="m-t-3 cus-padd cusheight">
          {spinner && <Spinner />}
          <header>
            <h2 className="page-tittle">Offers</h2>
            <hr />
          </header>
          {
            View_Permission ?
              <div className="row">
                <div className="col-sm-12 listpadding">
                  <div className="d-flex justify-content-end">
                    <div className='me-2'>
                      <select className='form-select' name="offerFilter" value={filter?.offerFilter} onChange={(e) => setFilter((pre) => ({ ...pre, offerFilter: e.target.value }))}>
                        <option value="ALL">All</option>
                        <option value="OFFER">Offer</option>
                        <option value="REWARDS">Rewards</option>
                      </select>
                    </div>
                    <div className='me-2'>
                      <select className='form-select' name="activeFilter" value={filter?.activeFilter} onChange={(e) => setFilter((pre) => ({ ...pre, activeFilter: e.target.value }))}>
                        <option value="ALL">All</option>
                        <option value="ACTIVE">Active</option>
                        <option value="EXPIRED">Expired</option>
                      </select>
                    </div>
                    <div>
                      <input
                        className="form-control"
                        type="text"
                        placeholder="Search by name"
                        onChange={(e) => setFilter((pre) => ({ ...pre, searchText: e.target.value }))}
                      />
                    </div>
                    <button className='btn ms-2 mb-3 btn_Style' type='submit' onClick={() => offerList()}>Search</button>
                    <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">Reset</Tooltip>}>
                      <i className="fa fa-refresh ms-3 mt-2 me-1" aria-hidden="true" onClick={() => filter?.searchText?.length ? window.location.reload() : null} style={{ marginRight: '-10px', cursor: 'pointer' }}></i>
                    </OverlayTrigger>
                  </div>
                  {
                    !offerListData?.length ? <NoRecord /> :

                      <div className="table-responsive">
                        <table className="table cus-table">
                          <thead className="text-center tableheader">
                            <tr>
                              <th scope="col">Image</th>
                              <th scope="col">Name</th>
                              <th scope="col">Service</th>
                              <th scope="col">Audience</th>
                              <th scope="col">Type</th>
                              <th scope="col">Date Range</th>
                              {(Edit_Permission || Create_Permission) ? <th scope="col">Action</th> : null}
                            </tr>
                          </thead>

                          <tbody>
                            {offerListData?.map((item, index) => (
                              <tr className={Edit_Permission ? 'cursor' : null} key={index}>
                                <td style={{ padding: '0.3rem .5rem' }} onClick={() => handleClick(item)}>
                                  <img src={item.image === '' ? Offer : imgFolder + item.image} alt="" height={30} width={30} style={{ borderRadius: '50%' }} />
                                </td>
                                <td onClick={() => handleClick(item)}>{item.name}</td>
                                <td onClick={() => handleClick(item)}>
                                  {item.serviceData?.map((data, i) =>
                                    <b key={i}>{i === 0 ? data.name.slice(0, 10) + (data.name.length > 10 ? "..." : "") : null}</b>
                                  )}
                                </td>
                                <td onClick={() => handleClick(item)}>{`${item.audience == null || !item?.audience?.gender?.length ? '--' : item.audience.gender}`}</td>
                                <td onClick={() => handleClick(item)}>{item?.offerType}</td>
                                <td onClick={() => handleClick(item)}>
                                  {moment(item.startDate).format('DD-MM-YYYY')} To {moment(item.endDate).format('DD-MM-YYYY')}
                                </td>
                                {
                                  (Edit_Permission || Create_Permission) &&
                                  <td>
                                    <Button variant="text" sx={{ color: 'black', fontSize: '12px' }} id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false">
                                      <i className="fa-solid fa-ellipsis-vertical cursor"></i>
                                    </Button>
                                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuLink">
                                      {Create_Permission && <a className="dropdown-item cursor" onClick={() => handleClick(item, 'REWARD')}>Clone</a>}
                                      {Delete_Permission && <a className="dropdown-item cursor" onClick={() => { setShowDelete(true); setOfferId(item._id) }}>Delete</a>}
                                      {
                                        item?.offerType === "OFFER" &&
                                        <a className="dropdown-item cursor" onClick={() => { SetSendPromotionMsg({ open: true, offerId: item?._id }); getClientList(); getAvailableCreditLimit() }}>Send Promotion Message</a>
                                      }
                                      {/* {
                                        item?.offerType === "OFFER" &&
                                        <a className="dropdown-item cursor" onClick={() => navigatePromotionalMessage(item._id)}>Promotional History</a>
                                      } */}
                                    </ul>
                                  </td>
                                }

                              </tr>
                            ))}
                          </tbody>

                        </table>
                        <div className="w-100 d-flex justify-content-center">
                          {count > 10 && (<Paginations setpage={setPage} count={Math.ceil(count / PER_PAGE)} page={page} />)}
                        </div>
                      </div>
                  }
                </div>
              </div>
              :
              <div className='d-flex justify-content-center mt-5 me-5'><h3>You don't have permission to access</h3></div>
          }
        </div>
        {
          Create_Permission ?
            <div className="d-flex justify-content-end">
              <div className="dropdown">
                <p className="mb-4 me-3  addbtn2" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                  <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">Create Offer</Tooltip>}>
                    <i className="fa-solid fa-plus"></i>
                  </OverlayTrigger>
                </p>
                <ul className="dropdown-menu dropdown-menu-end">
                  <li className="dropdown-item cursor" onClick={() => { setShowOffer(true); servicesList(); setZeroOffer(false); setRewardOffer(false) }}>
                    Create Offer
                  </li>
                  <li className="dropdown-item cursor" onClick={() => { setShowOffer(true); servicesList(); setZeroOffer(false); setRewardOffer(true) }}>
                    Create Reward
                  </li>
                </ul>
              </div>
            </div>
            : null
        }


      </section>

      <AddOffer rewardOffer={rewardOffer} zeroOffer={zeroOffer} setZeroOffer={setZeroOffer} fileInputRef={fileInputRef} imageDeleteUpload={imageDeleteUpload} showOffer={showOffer} setShowOffer={setShowOffer} createOffer={createOffer} setImageData={setImageData}
        setMale={setMale} setFemale={setFemale} setOther={setOther} imageUpload={uploadImage}
        imageData={imageData} male={male} female={female} other={other} date={date} valuetext={valuetext} navigate={navigate} serviceList={serviceList} handleChange={handleChange} value={value}
        imgFolder={imgFolder} setInActive={setInActive} />

      <EditOffer rewardOffer={rewardOffer} zeroOffer={zeroOffer} setZeroOffer={setZeroOffer} fileInputRef={fileInputRef} offerId={offerId} imageDelete={imageDelete} show={show} setShow={setShow} setImageData={setImageData} male={male} setMale={setMale} female={female}
        setFemale={setFemale} other={other} setOther={setOther} imageData={imageData}
        imageUpload={uploadImage} editOffer={editOffer} value={value} serviceList={serviceList} moment={moment} handleChange={handleChange} imgFolder={imgFolder} valuetext={valuetext} setInActive={setInActive}
        inActive={inActive} selectedService={selectedService} />

      {/* Offer Delete*/}
      <>
        <Modal show={showDelete} size="sm" centered onHide={() => setShowDelete(false)} >
          <div className="modal-content">
            <div className="modal-body text-center">
              <p>Are you sure !</p>
              <p>You want to delete this offer</p>
              <button type="button" className="btn yesbtn" data-bs-dismiss="modal" onClick={() => offerDelete()}  >
                Yes
              </button>
              <button type="button" className="btn nobtn ms-1" data-bs-dismiss="modal" onClick={() => setShowDelete(false)} >
                No
              </button>
            </div>
          </div>
        </Modal>
      </>

      <Modal centered show={sendPromotionMsg?.open} onHide={() => clear()}>
        <div className="modal-content">
          <div className="text-end m-3">
            Available Credits: <span style={{ color: '#F47D3A' }}> <strong>{creditLimit}</strong></span>

          </div>
          <div className="d-flex justify-content-between align-items-center mt-2">
  <div className="col-sm-6" style={{marginLeft:'25px'}}>
    <input
      type="text"
      className="form-control"
      id="recipient-name"
      name="query"
      placeholder="Search by name"
      onChange={handleSearch}
      value={query}
    />
  </div>
  <div className="col-sm-3" style={{marginRight:'15px'}}>
    <select
      id="gender"
      className="form-select"
      value={gender}
       onChange={handleGenderChange}
    >
      <option value="ALL">All</option>
      <option value="MALE">Male</option>
      <option value="FEMALE">Female</option>
    </select>
  </div>
</div>

          <div className="p-1 border-bottom mt-3">
            <h5 className="modal-title text-center mb-3" id="exampleModalLabel">
              <strong>Select Clients</strong>
            </h5>
          </div>


          <div className="px-4 py-3" style={{ maxHeight: '300px', overflowY: 'auto' }}>
            {clientList.length > 0 && (
              <div className="form-check mb-3 d-flex align-items-center">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="select-all"
                  checked={isAllSelected}
                  onChange={handleSelectAll}
                />
                <label className="form-check-label ms-2" htmlFor="select-all">
                  {isAllSelected ? 'Deselect All' : 'Select All'}
                </label>
              </div>
            )}
            {clientList.length ? (
              clientList.map((client) => (
                <>
                  <hr />

                  <div key={client.id} className="form-check mb-2 d-flex align-items-center">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id={`client-${client._id}`}
                      checked={!!selectedClients[client._id]}
                      onChange={() => handleToggle(client._id)}
                    />
                    <label className="form-check-label ms-2" htmlFor={`client-${client._id}`}>
                      {client.name}
                    </label>
                  </div>

                </>
              ))
            ) : (
              <p className="text-muted text-center">No clients available.</p>
            )}
          </div>

          <div className="modal-footer d-flex justify-content-center   border-top px-4 py-3">
            <button type="button" className="btn nobtn ms-1" data-bs-dismiss="modal" onClick={() => clear()} >
              Cancel
            </button>
            <button type="button" className="btn yesbtn" data-bs-dismiss="modal" onClick={handleSubmit}  >
              Submit
            </button>
          </div>
        </div>
      </Modal>


      <Modal centered show={creditLimitModalMsg?.open} onHide={() => clear()}>
        <div className="p-3 pb-0 border-bottom d-flex justify-content-between align-items-center">
          <h5 className="mb-0">Confirm Purchase</h5>

        </div>

        <Modal.Body className="text-start p-4">
          <p>{creditLimitModalMsg?.message}</p>
          <div className="d-flex justify-content-end mt-4 gap-2">

            <button type="button" className="btn nobtn" data-bs-dismiss="modal" onClick={() => clear()}>
              No
            </button>

            <button type="button" className="btn yesbtn" data-bs-dismiss="modal" onClick={() => {
              buyPlanNavigate()
            }}>
              Buy now
            </button>

          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default OfferList;
